import React from 'react';
import propTypes from 'prop-types';
import { Route, Routes } from 'react-router-dom';
import { PeopleListPage } from './PeopleListPage';
import { PersonEditPageWrapper } from './PersonEditPageWrapper';
import { PeopleAllowedReportsPage } from './PeopleAllowedReportsPage';

export function PeoplePage({ isExpanded, location }) {
  return (
    <Routes location={location}>
      <Route path="/" element={<PeopleListPage />} />
      <Route
        path="edit/:id"
        element={<PersonEditPageWrapper isExpanded={isExpanded} />}
      />
      <Route
        path="allowed-reports"
        element={<PeopleAllowedReportsPage isExpanded={isExpanded} />}
      />
    </Routes>
  );
}

PeoplePage.propTypes = {
  isExpanded: propTypes.bool.isRequired,
  location: propTypes.object.isRequired,
};
